import {AuthenticationRepository} from '@/profile-creation-wizard/components/for-completion/domain/authentication/AuthenticationRepository';
import {context} from 'vue3-starter/src/typescript/app-context/AppContext';

export class AuthenticationRepositoryAPI implements AuthenticationRepository {
    async logout(): Promise<void> {
        await context.httpService.post(context.registry.entries.logout());
    }
}
